import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private isLoading = new BehaviorSubject<boolean>(false);

  // Get the loading state as an observable
  get loading$(): Observable<boolean> {
    return this.isLoading.asObservable();
  }

  // Show the loader
  show() {
    this.isLoading.next(true);
  }

  // Hide the loader
  hide() {
    this.isLoading.next(false);
  }
}
